'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _rollupPluginBabelHelpers = require('../../../../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var React__default = _interopDefault(React);
var PropTypes = _interopDefault(require('prop-types'));
var classNames = _interopDefault(require('classnames/dedupe'));
require('./_index.scss.js');

var CLASSNAME = 'varta-tabs',
    cnHeader = "".concat(CLASSNAME, "__header"),
    cnHeaderCentered = "".concat(cnHeader, "--centered"),
    cnLink = "".concat(CLASSNAME, "__link"),
    cnLinkActive = "".concat(cnLink, "--active");
/**
 * @class Tabs
 */

function Tabs(_ref) {
  var _filteredItems$, _filteredItems$active;

  var centerHeader = _ref.centerHeader,
      className = _ref.className,
      items = _ref.items,
      onChange = _ref.onChange;

  var _useState = React.useState(),
      _useState2 = _rollupPluginBabelHelpers.slicedToArray(_useState, 2),
      activeTab = _useState2[0],
      setActiveTab = _useState2[1];

  var filteredItems = items.filter(function (a) {
    return !!a;
  });

  if (!filteredItems.length) {
    return null;
  }

  var activeIndex = typeof activeTab === 'undefined' ? Math.max(filteredItems.findIndex(function (a) {
    return a === null || a === void 0 ? void 0 : a.active;
  }), 0) : activeTab;
  return /*#__PURE__*/React__default.createElement("div", {
    className: classNames(className, CLASSNAME)
  }, /*#__PURE__*/React__default.createElement("header", {
    className: classNames(cnHeader, _rollupPluginBabelHelpers.defineProperty({}, cnHeaderCentered, centerHeader))
  }, filteredItems.length > 1 ? filteredItems.filter(function (a) {
    return !!a;
  }).map(function (item, index) {
    return /*#__PURE__*/React__default.createElement("a", {
      href: "#",
      key: index,
      className: classNames(cnLink, _rollupPluginBabelHelpers.defineProperty({}, cnLinkActive, index === activeIndex)),
      onClick: function onClick(e) {
        e.preventDefault();
        setActiveTab(index);

        if (onChange) {
          onChange(index);
        }
      }
    }, item.title);
  }) : /*#__PURE__*/React__default.createElement("h4", null, (_filteredItems$ = filteredItems[0]) === null || _filteredItems$ === void 0 ? void 0 : _filteredItems$.title)), /*#__PURE__*/React__default.createElement("div", null, (_filteredItems$active = filteredItems[activeIndex]) === null || _filteredItems$active === void 0 ? void 0 : _filteredItems$active.content));
}
Tabs.propTypes = {
  /** True for centering header */
  centerHeader: PropTypes.bool,

  /** Additional class name */
  className: PropTypes.string,

  /** Array of tab items */
  items: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string.isRequired,
    active: PropTypes.bool,
    content: PropTypes.node
  })).isRequired,

  /** Callback function */
  onChange: PropTypes.func
};
Tabs.defaultProps = {
  items: []
};

module.exports = Tabs;
